import styled from 'styled-components'
import { Checkbox } from 'antd'
import { THEME } from '../../themes'

export const CheckboxComponent = styled(Checkbox)`
	color: ${THEME.COLORS.RED};
  font-size: 12px;
`
